import React from 'react'
import {urlFor} from '../lib/client';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { RiCloseCircleLine } from "react-icons/ri";
import { TfiClose } from "react-icons/tfi";


import VisDiv from './frontend_components/VisDiv';

const StoryIcon = ({icon, archived, title, iconStyle={}, fontSize, iconSize, vertical, additionalTitle, plus, isActive}) => {

  const marginIconLeft = (iconSize * 6)/100

  const plusStyle = plus && {marginTop:"-10px"}
  const activeBorder = isActive && {border:"2px solid blue", borderRadius:"50%", paddingLeft: `${marginIconLeft}px`, paddingTop: `${marginIconLeft}px`}
  return (
    <div className='story-container' style={{fontSize:fontSize}}>
      <VisDiv rules={[plus, icon]} style={{position:"relative", marginLeft:`${iconSize - 15}px`, backgroundColor:"white", borderRadius:"50%"}}><BsFillPlusCircleFill size={15} color='red'/></VisDiv>
        { icon && (<div style={{display:"flex", marginRight:"5px",...activeBorder, ...plusStyle, ...iconStyle}}>
          <img src={urlFor(icon)} alt="register-icon" className="register-logo" style={{width: iconSize, height: iconSize }} />
        </div>)}
        { archived && (<div style={{marginRight:"5px", marginTop:`${-iconSize}px`}}><TfiClose size={iconSize} color='white'/></div>)}
        { title && (<h1>{title}</h1> )} 
        { additionalTitle ? (<h1>{additionalTitle}</h1> ): vertical && (<h1 style={{color:"rgba(255, 0, 0, 0)", }}>_</h1> )} 
    </div>
  )
}

export default StoryIcon

//`${-iconSize}px
/* 
         { icon && (<img src={icon} alt="register-icon" className="register-logo" />)}
        { title && (<h1>{title}</h1> )} 
*/


